import { MarketingConsentSection } from './MarketingConsentSection';
import { useMarketingConsent } from '@/hooks/useMarketingConsent';
import { getMarketingConsentStrings } from '@/i18n/marketingConsent';
import type { Locale } from '@/config/locales';
import { Button } from '@/components/ui/button';

interface MarketingConsentReviewProps {
  customerKey: number | string | null;
  locale: Locale;
  isCurrent: () => boolean;
  onContinue: () => void;
}

/** Optional consent requires the authenticated notice and a fresh explicit action. */
export function MarketingConsentReview({ customerKey, locale, isCurrent, onContinue }: MarketingConsentReviewProps) {
  const marketing = useMarketingConsent({ enabled: customerKey !== null, customerKey });
  const strings = getMarketingConsentStrings(locale);
  return (
    <div className="mx-auto w-full max-w-2xl p-4" data-testid="marketing-consent-review">
      <MarketingConsentSection
        strings={strings}
        notice={marketing.notice}
        consent={marketing.consent}
        isLoading={marketing.isInitialLoading}
        loadError={marketing.initialError !== null}
        isUpdating={marketing.isUpdating}
        mutationError={marketing.mutationError !== null}
        isNoticeStale={marketing.isNoticeStale}
        lastSuccess={marketing.lastSuccess}
        onRetryLoad={marketing.retry}
        onUpdate={(status) => { if (isCurrent()) void marketing.update(status); }}
      />
      <Button className="mt-6" type="button" data-testid="marketing-login-continue" disabled={marketing.isUpdating}
        onClick={() => { if (isCurrent()) onContinue(); }}>
        {strings.continueLogin}
      </Button>
    </div>
  );
}
